import canUseDOM from '../utils/canUseDOM'

const Hammer = canUseDOM && require('hammerjs')

export const padDown = {
  bind: function(el, binding) {
    if (typeof binding.value === "function") {
      const mc = new Hammer(el);
      mc.get("pan").set({ direction: Hammer.DIRECTION_ALL, domEvents: true });
      mc.on("pandown panend", binding.value);
    }
  }
}
